import axios from "axios";
import store from "../index";

const state = {

};

const getters = {


};

const actions = {

    asyncFetchData : async(context,payload) => {

        let url = "currencies";
        return axios.get(`${context.rootGetters['settings/getUrl']}${url}`,

            {
                'headers': {'Authorization': `Bearer ${context.rootGetters['profile/getToken']}`},
                "Content-Type": "application/json"
            },payload)
            .then(success => {
                //console.log(success.data)


                return success

            }).
            catch(error => {

                return  error.response
            });


    },

};

const mutations = {

};



export default {
    namespaced : true,
	state,
	mutations,
	getters,
	actions
}
